export default __webpack_public_path__ + "static/media/hero-hiring-team-v2.b1069662.webp";